import { useState } from 'react';
import UsageInfo from '../../components/UsageInfo';
import { DeleteButton } from '../../components/ActionButtons';

const INIT_SAYFALAR = [
  { id: 1, baslik: 'Ana Sayfa',       slug: '/',           durum: 'yayinda', tur: 'sistem', guncelleme: '10.03.2026' },
  { id: 2, baslik: 'Hakkımızda',      slug: '/hakkimizda', durum: 'yayinda', tur: 'normal', guncelleme: '08.03.2026' },
  { id: 3, baslik: 'Odalar',          slug: '/odalar',     durum: 'yayinda', tur: 'sistem', guncelleme: '10.03.2026' },
  { id: 4, baslik: 'Galeri',          slug: '/galeri',     durum: 'yayinda', tur: 'normal', guncelleme: '05.03.2026' },
  { id: 5, baslik: 'İletişim',        slug: '/iletisim',   durum: 'yayinda', tur: 'sistem', guncelleme: '01.03.2026' },
  { id: 6, baslik: 'Rezervasyon',     slug: '/rezervasyon',durum: 'yayinda', tur: 'sistem', guncelleme: '10.03.2026' },
  { id: 7, baslik: 'Hizmetlerimiz',   slug: '/hizmetler',  durum: 'taslak',  tur: 'normal', guncelleme: '02.03.2026' },
  { id: 8, baslik: 'SSS',             slug: '/sss',        durum: 'taslak',  tur: 'normal', guncelleme: '28.02.2026' },
];

export default function WebSiteSayfalar() {
  const [sayfalar, setSayfalar] = useState(INIT_SAYFALAR);
  const [yeniBaslik, setYeniBaslik] = useState('');
  const [silOnay, setSilOnay] = useState(null);

  const eklenebilir = yeniBaslik.trim().length > 0;

  const handleEkle = () => {
    if (!eklenebilir) return;
    const slug = '/' + yeniBaslik.trim().toLocaleLowerCase('tr-TR')
      .replace(/\s+/g, '-')
      .replace(/[ğ]/g, 'g').replace(/[ü]/g, 'u').replace(/[ş]/g, 's').replace(/[ı]/g, 'i').replace(/[ö]/g, 'o').replace(/[ç]/g, 'c');
    
    setSayfalar(p => [
      { 
        id: Date.now(), 
        baslik: yeniBaslik.trim().toUpperCase(), 
        slug, 
        durum: 'taslak', 
        tur: 'normal', 
        guncelleme: new Date().toLocaleDateString('tr-TR') 
      }, 
      ...p
    ]);
    setYeniBaslik('');
  };

  return (
    <div className="p-3 md:p-6 space-y-7 min-h-screen bg-gray-50/50 animate-fadeIn" style={{ transform: 'translateZ(0)' }}>
      
      {/* Premium Header */}
      <div className="bg-white rounded-[2.5rem] border border-gray-200 shadow-sm p-6 md:p-8 relative overflow-hidden">
        <div className="absolute top-0 right-0 -mr-16 -mt-16 w-64 h-64 bg-blue-50 rounded-full blur-3xl opacity-60 pointer-events-none" style={{ transform: 'translateZ(0)', willChange: 'transform' }}></div>
        <div className="relative flex flex-col md:flex-row md:items-center justify-between gap-8">
          <div className="flex items-center gap-6 min-w-0">
            <div className="w-16 h-16 bg-gradient-to-br from-indigo-600 to-violet-700 rounded-2xl flex-shrink-0 flex items-center justify-center text-white text-3xl shadow-2xl shadow-indigo-200">📄</div>
            <div className="min-w-0">
              <h1 className="text-2xl md:text-3xl font-black text-gray-900 tracking-tighter truncate uppercase">Web Sayfaları</h1>
              <p className="text-sm font-bold text-gray-400 mt-1 uppercase tracking-widest truncate">Sitenizdeki statik ve dinamik içerikleri yönetin</p>
            </div>
          </div>
          
          <div className="flex items-center gap-3 bg-gray-50/50 p-2 rounded-3xl border-2 border-gray-100 flex-1 md:flex-none">
            <input 
              value={yeniBaslik} 
              onChange={e => setYeniBaslik(e.target.value)}
              className="bg-transparent text-gray-800 placeholder:text-gray-300 text-xs font-black uppercase tracking-widest focus:outline-none px-4 flex-1 md:w-48"
              placeholder="YENİ SAYFA BAŞLIĞI..."
              onKeyDown={e => e.key === 'Enter' && handleEkle()}
            />
            <button 
              onClick={handleEkle}
              disabled={!eklenebilir}
              className={`px-6 py-3 rounded-2xl text-[10px] font-black transition-[background-color,box-shadow,transform] duration-200 uppercase tracking-widest shadow-lg ${
                eklenebilir ? 'bg-indigo-600 text-white shadow-indigo-100 hover:bg-indigo-700' : 'bg-gray-200 text-gray-400 shadow-none cursor-not-allowed'
              }`}
            >
              + EKLE
            </button>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-[2.5rem] border border-gray-100 shadow-sm overflow-hidden">
        <div className="px-8 py-5 border-b border-gray-50 bg-gray-50/30 flex items-center justify-between">
            <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Sistemde TOPLAM <b className="text-indigo-600">{sayfalar.length}</b> Sayfa Tanımlı</p>
        </div>

        {/* Masaüstü Tablo Görünümü */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-50/50 border-b border-gray-100">
                <th className="text-left py-5 px-8 text-[11px] font-black text-gray-500 uppercase tracking-widest">Sayfa Künyesi</th>
                <th className="text-left py-5 px-8 text-[11px] font-black text-gray-500 uppercase tracking-widest">URL / Slug</th>
                <th className="text-left py-5 px-8 text-[11px] font-black text-gray-500 uppercase tracking-widest">Tip</th>
                <th className="text-left py-5 px-8 text-[11px] font-black text-gray-500 uppercase tracking-widest">Statü</th>
                <th className="text-left py-5 px-8 text-[11px] font-black text-gray-500 uppercase tracking-widest">Güncelleme</th>
                <th className="py-5 px-8 text-right text-[11px] font-black text-gray-500 uppercase tracking-widest">İşlemler</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {sayfalar.map(s => (
                <tr key={s.id} className="hover:bg-blue-50/20 transition-colors duration-200 group">
                  <td className="py-6 px-8">
                    <div className="flex items-center gap-3">
                       <span className="text-xl opacity-40 group-hover:opacity-100 transition-opacity">{s.tur === 'sistem' ? '⚙️' : '📄'}</span>
                       <span className="font-black text-gray-800 uppercase tracking-tight text-sm">{s.baslik}</span>
                    </div>
                  </td>
                  <td className="py-6 px-8">
                    <span className="text-[11px] font-mono font-bold text-blue-500 bg-blue-50 px-2.5 py-1.5 rounded-lg border border-blue-100/50 tracking-tighter">
                      {s.slug}
                    </span>
                  </td>
                  <td className="py-6 px-8">
                    <span className={`text-[9px] font-black px-2.5 py-1.5 rounded-lg uppercase tracking-widest border ${
                      s.tur === 'sistem' ? 'bg-indigo-50 text-indigo-600 border-indigo-100' : 'bg-gray-50 text-gray-500 border-gray-100'
                    }`}>
                      {s.tur}
                    </span>
                  </td>
                  <td className="py-6 px-8 text-center sm:text-left">
                    <button 
                      onClick={() => setSayfalar(p => p.map(x => x.id === s.id ? {...x, durum: x.durum === 'yayinda' ? 'taslak' : 'yayinda'} : x))}
                      className={`text-[9px] font-black px-3 py-1.5 rounded-xl transition-all uppercase tracking-widest shadow-sm hover:scale-105 active:scale-95 ${
                        s.durum === 'yayinda' ? 'bg-emerald-50 text-emerald-600 border border-emerald-200' : 'bg-rose-50 text-rose-500 border border-rose-200'
                      }`}
                    >
                      {s.durum === 'yayinda' ? '🟢 Yayında' : '🟠 Taslak'}
                    </button>
                  </td>
                  <td className="py-6 px-8">
                     <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{s.guncelleme}</span>
                  </td>
                  <td className="py-6 px-8 text-right">
                    <div className="flex items-center justify-end gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <button className="text-[10px] font-black px-4 py-2 bg-white hover:bg-gray-50 text-gray-800 border-2 border-gray-100 rounded-xl transition-all uppercase tracking-widest shadow-sm">Düzenle</button>
                      {s.tur !== 'sistem' && (
                        <button 
                          onClick={() => setSilOnay(s.id)}
                          className="text-[10px] font-black px-4 py-2 bg-rose-50 hover:bg-rose-100 text-rose-600 border border-rose-200 rounded-xl transition-all uppercase tracking-widest"
                        >
                          Sil
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobil Kart Görünümü (375px+) */}
        <div className="md:hidden divide-y divide-gray-100">
          {sayfalar.map(s => (
            <div key={s.id} className="p-6 space-y-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 min-w-0">
                  <div className="w-10 h-10 bg-gray-50 rounded-xl flex items-center justify-center text-lg">{s.tur === 'sistem' ? '⚙️' : '📄'}</div>
                  <div className="truncate">
                    <p className="font-black text-gray-800 text-sm uppercase truncate">{s.baslik}</p>
                    <p className="text-[10px] font-mono text-gray-400 truncate">{s.slug}</p>
                  </div>
                </div>
                <button 
                  onClick={() => setSayfalar(p => p.map(x => x.id === s.id ? {...x, durum: x.durum === 'yayinda' ? 'taslak' : 'yayinda'} : x))}
                  className={`text-[9px] font-black px-3 py-1.5 rounded-xl uppercase tracking-widest border transition-all ${
                    s.durum === 'yayinda' ? 'bg-emerald-50 text-emerald-600 border-emerald-200' : 'bg-rose-50 text-rose-500 border-rose-200'
                  }`}
                >
                  {s.durum === 'yayinda' ? 'YAYINDA' : 'TASLAK'}
                </button>
              </div>
              <div className="flex items-center justify-between pt-2">
                <div className="flex gap-2">
                  <span className="text-[9px] font-black px-2 py-1 bg-gray-100 text-gray-400 rounded-md uppercase">{s.tur}</span>
                  <span className="text-[9px] font-bold text-gray-300 uppercase mt-1">{s.guncelleme}</span>
                </div>
                <div className="flex gap-2">
                  <button className="p-2 text-indigo-600 hover:bg-indigo-50 rounded-lg border border-indigo-100 transition-all">📝</button>
                  {s.tur !== 'sistem' && (
                     <DeleteButton onClick={() => setSilOnay(s.id)} />
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <UsageInfo 
        color="indigo"
        description="Sitenizdeki sayfaları buradan yönetebilir, yeni sayfalar ekleyebilir veya yayından kaldırabilirsiniz. Sistem sayfaları sitenizin temel işleyişi için gereklidir ve silinemezler."
        scenarios={[
          { title: "Yeni Sayfa Ekleme", content: "Üst kısımdaki 'Yeni sayfa başlığı' alanına başlığı yazıp 'Ekle' butonuna basmanız yeterlidir. URL otomatik olarak Türkçe karakter desteğiyle oluşturulur." },
          { title: "Sistem Sayfaları", content: "Rezervasyon, İletişim ve Odalar gibi sayfalar sistemin kalbidir. Bunları silemezsiniz ancak düzenleyerek içeriğini değiştirebilirsiniz." },
          { title: "Taslak Durumu", content: "Bir sayfayı tam yayınlamadan önce 'Taslak' durumuna getirerek genel ziyaretçilere kapatabilir, sadece yönetim panelinden görüntüleyebilirsiniz." }
        ]}
      />

      {/* Silme Onay Modalı - Ultra Premium */}
      {silOnay && (
        <div className="fixed inset-0 bg-gray-900/40 backdrop-blur-md z-[100] flex items-center justify-center px-4" style={{ animation: 'fadeIn 0.2s ease-out' }}>
          <div className="bg-white rounded-[2.5rem] shadow-2xl p-8 md:p-12 w-full max-w-sm text-center border-t-8 border-rose-500 relative overflow-hidden">
            <div className="absolute top-0 right-0 p-4">
              <button onClick={() => setSilOnay(null)} className="text-gray-300 hover:text-gray-500 flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 font-bold transition-all">✕</button>
            </div>
            <div className="w-20 h-20 bg-rose-50 rounded-3xl flex items-center justify-center text-4xl mx-auto mb-6 shadow-inner text-rose-500">🗑️</div>
            <h3 className="text-xl font-black text-gray-900 tracking-tighter uppercase">SAYFAYI SİL?</h3>
            <p className="text-xs font-bold text-gray-400 mt-2 mb-8 uppercase tracking-widest leading-relaxed">
              <b className="text-gray-800">{sayfalar.find(x=>x.id===silOnay)?.baslik}</b> sayfası kalıcı olarak silinecektir. Bu işlem geri alınamaz.
            </p>
            <div className="flex gap-4">
              <button onClick={() => setSilOnay(null)} className="flex-1 py-4 border-2 border-gray-100 rounded-2xl text-[10px] font-black text-gray-400 uppercase tracking-widest hover:border-gray-200 transition-all">Vazgeç</button>
              <button 
                onClick={() => { setSayfalar(p => p.filter(x => x.id !== silOnay)); setSilOnay(null); }}
                className="flex-1 py-4 bg-rose-500 text-white rounded-2xl text-[10px] font-black uppercase tracking-widest shadow-xl shadow-rose-200 hover:bg-rose-600 transition-all"
              >
                Sil
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeIn { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
      `}</style>
    </div>
  );
}